var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'carousel',
    { 'carousel--stack-on-mobile': _vm.stackOnMobile },
    {
      'carousel-vertical': _vm.vertical,
      'carousel-text-selectable': !_vm.swipeOnDesktop,
    } ],attrs:{"id":_vm.carouselIdentifier}},[_c('div',{staticClass:"carousel-wrapper"},[_c('ul',{ref:"carouselInner",staticClass:"carousel-inner",style:({
        transform: ("translate" + (this.vertical ? 'Y' : 'X') + "(" + (this.currentOffset) + "px)"),
        transition: this.transitionStyle,
        flexBasis: this.isVideoCarousel ? 'unset' : ((this.slideWidth) + "px"),
        msFlexPreferredSize: ((this.slideWidth) + "px"),
        visibility: ("" + (this.slideWidth ? 'visible' : 'hidden')),
      })},[_vm._t("default")],2)]),(_vm.paginationEnabled && _vm.pageCount > 0)?_c('pagination',{attrs:{"labels":_vm.labels}}):_vm._e(),_c('navigation',{attrs:{"show-navigation":_vm.showNavigation,"autoplay":_vm.autoplay,"labels":_vm.labels},on:{"changeSlide":_vm.advancePage,"toggleAutoPlay":_vm.toggleAutoPlay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }